// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Rp3C","largestCol":"styles_largestCol__x6fQk","smallestCol":"styles_smallestCol__3lg6L"};